import { render, staticRenderFns } from "./ModalAddEbook.vue?vue&type=template&id=f4c5b68c&scoped=true&"
import script from "./ModalAddEbook.vue?vue&type=script&lang=js&"
export * from "./ModalAddEbook.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEbook.vue?vue&type=style&index=0&id=f4c5b68c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c5b68c",
  null
  
)

export default component.exports